import Appointment from '@spike/appointment-model';

type DurationMetadata = { hours?: number; minutes?: number };

const metadataMinutes = (metadata?: DurationMetadata | null): number => {
    if (!metadata) return 0;
    return (metadata.hours ?? 0) * 60 + (metadata.minutes ?? 0);
};

const timeWindowMinutes = (appointment: Appointment): number => {
    const from = appointment.duration?.from;
    const to = appointment.duration?.to;
    if (!from || !to) return 0;
    return Math.max(0, to.clone().diff(from.clone(), 'minutes'));
};

/**
 * Training/walking duration for display and edit.
 * Catalog snapshot in serviceVariableDuration often stays at the original service duration
 * after edits; prefer appointment-level details / time window when they diverge from it.
 */
export const getTrainingOrWalkingDurationMinutes = (appointment: Appointment, businessAreaId?: string): number => {
    const areaId = businessAreaId ?? appointment.services[0]?.businessArea?.id;
    const windowMinutes = timeWindowMinutes(appointment);
    const variable = appointment.serviceVariableDuration as DurationMetadata | undefined;
    const catalogMinutes = metadataMinutes(variable);

    const detailsMinutes =
        areaId === 'training'
            ? appointment.details?.training?.duration ?? 0
            : areaId === 'walking'
            ? appointment.details?.walking?.duration ?? 0
            : 0;

    if (areaId !== 'training' && areaId !== 'walking') {
        return windowMinutes;
    }

    if (detailsMinutes > 0 && detailsMinutes !== catalogMinutes) {
        return detailsMinutes;
    }
    if (windowMinutes > 0 && windowMinutes !== catalogMinutes) {
        return windowMinutes;
    }
    if (detailsMinutes > 0) {
        return detailsMinutes;
    }
    if (windowMinutes > 0) {
        return windowMinutes;
    }
    return catalogMinutes;
};
